export default __webpack_public_path__ + "static/media/amount.4a4a6fd6.svg";